import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";

import MarkdownStylesheetQuickEditor from "../shared/markdownStylesheetQuickEditor";
import JsonPreviewEditor from "./jsonPreviewEditor";

class StylesheetEditor extends PureComponent {
	render() {
		return (
			<JsonPreviewEditor
				{...this.props}
				emptyValue={{}}
				previewPreferenceKey="stylesheet"
				previewLabel="Preview Activity"
				previewNoun="this stylesheet"
				renderBeforeEditor={({ editContent, onChangeContent }) => (
					<MarkdownStylesheetQuickEditor
						titleLabel="Global Markdown Style"
						description="These controls write into this stylesheet under markdown. They author default Markdown rendering anywhere this stylesheet is used."
						introText="Tune Markdown typography, blockquotes, lists, links, code, and table basics for activities using this organization or Drive stylesheet."
						previewText="Preview reflects the Markdown rules authored into this stylesheet. Activity, list, section, and item styles can still override these values at runtime."
						stylesheetValue={editContent}
						onChangeStylesheet={onChangeContent}
					/>
				)}
			/>
		);
	}
}

export default branch({
	activities: ["activities"],
	activitiesMap: ["activitiesMap"],
	selectedChecklistId: ["selectedChecklistId"],
	root: ["tree", "root"]
}, StylesheetEditor);
